module.exports = __webpack_public_path__ + "img/scene5-13.6252c9f5.jpg";